




import { Component, Vue } from "vue-property-decorator";
import { getTitleFromMetadata } from "@/middleware/buildRouteMetadata";

@Component({ name: "app-title" })
export default class AppTitle extends Vue {
  title = "";

  beforeMount() {
    const title = getTitleFromMetadata(this.$route.meta);
    if (title) this.title = title;
    this.$eventHub.$on("update-title", (title: string | undefined) => {
      if (title) {
        this.title = title;
      }
      this.$forceUpdate();
    });
  }

  beforeDestroy() {
    this.$eventHub.$off("update-title");
  }
}
